import {
  Button,
  Card,
  ContextualMenu,
  DatePicker,
  FilePicker,
  Group,
  IconDocument,
  IconHelp,
  IconPencil,
  IconTrash,
  IconWarningAlt,
  Modal,
  MomentObj,
  OptionInterface,
  OptionValue,
  Table,
  TableColumns,
  TableData,
  TablePagination,
  TextBox,
} from "@veneer/core";
import "../../assets/css/views/appointment/appointmentControl.css";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useTranslation } from "react-i18next";
import AgendaManagement from "../../services/agendaApi/agendaManagement";
import { Workbook } from "exceljs";
import {
  IJsonAppointmentControlDto,
  IUpdateAppointmentControlDto,
  IValuesAppointmentControl,
} from "../../models/dto/agendaApi/IAppointmentControlDto";
import { saveAs } from "file-saver";
import { Grid } from "@mui/material";
import moment from "moment";
import { Moment } from "moment";
import { ModalInformational } from "../SellOut/SellOutComponent/ModalInformational";
import { Trans } from "react-i18next";

export default function AppointmentControl() {
  const [t] = useTranslation("global");
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalCreateSellOut, setOpenModalCreateSellOut] = useState(false);
  const [openModalUpdateAppointment, setOpenModalUpdateAppointment] =
    useState(false);
  const [buttonNext, setButtonNext] = useState(true);
  const [fileName, setFileName] = useState<string>("");
  const [errorFilePicker, setErrorFilePicker] = useState(false);
  const [jsonDate, setJsonDate] = useState<IJsonAppointmentControlDto[]>([]);
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [valueAppointmentDelete, setValueAppointmentDelete] =
    useState<number>(0);
  const [messageModal, setMessageModal] = useState({
    title: "",
    message: "",
  });
  const tableDataRef = useRef<any["TableData"]>([]);

  const initialValues: IValuesAppointmentControl = {
    Columns: [],
    Update: {
      idUser: "",
      name: "",
      lastName: "",
      appointmentDate: "",
      poscode: "",
      checkInTime: "",
      checkOutTime: "",
      appointmentId: "",
      rowConfig: {},
    },
    Date: undefined,
    StartDate: undefined,
    EndDate: undefined,
  };

  const [values, setValues] = useState({ ...initialValues });

  useEffect(() => {
    handleOnDateChange(moment());
  }, []);

  const handleChangeSearch = (value: string, field: string) => {
    const filteredData = tableDataRef.current.filter((row: any) =>
      row[field]?.toLowerCase().includes(value.toLowerCase())
    );

    setTableData(filteredData);
    setCurrentPage(1);
  };

  const columnConfigMap: Record<string, TableColumns[]> = {
    GetAppointmentControl: [
      {
        id: "idUser",
        label: t("header.userId"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) => handleChangeSearch(value, "idUser")}
          />
        ),
      },
      {
        id: "name",
        label: t("header.name"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) => handleChangeSearch(value, "name")}
          />
        ),
      },
      {
        id: "lastName",
        label: t("header.lastName"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) => handleChangeSearch(value, "lastName")}
          />
        ),
      },
      {
        id: "appointmentDate",
        label: t("header.date"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) =>
              handleChangeSearch(value, "appointmentDate")
            }
          />
        ),
      },
      {
        id: "poscode",
        label: t("header.posOfCode"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) => handleChangeSearch(value, "poscode")}
          />
        ),
      },
      {
        id: "checkInTime",
        label: t("header.startTime"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) =>
              handleChangeSearch(value, "checkInTime")
            }
          />
        ),
      },
      {
        id: "checkOutTime",
        label: t("header.endTime"),
        filter: (
          <TextBox
            id="attendanceTextboxUser"
            label={t("header.search")}
            type="search"
            onChange={(value: string) =>
              handleChangeSearch(value, "checkOutTime")
            }
          />
        ),
      },
    ],
  };

  const getTableColumns = (name: string): TableColumns[] => {
    return columnConfigMap[name];
  };

  const pagedData = tableData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setPageSize(option.value);
  };

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  const fillUpdate = (value: string | number) => {
    const selectedRow = tableDataRef.current.find(
      (row: any) => row.appointmentId === value
    );

    if (selectedRow) {
      const updatedRow = {
        ...selectedRow,
        checkInTime: selectedRow.checkInTime.slice(0, 5),
        checkOutTime: selectedRow.checkOutTime.slice(0, 5),
      };

      setButtonNext(false);

      setValues((prevState: any) => ({
        ...prevState,
        Update: updatedRow,
      }));

      setOpenModalUpdateAppointment(true);
    }
  };

  const deleteAppointmentControl = async (value: string | number) => {
    try {
      const result = await AgendaManagement.deleteAppointmentControl(
        Number(value)
      );

      if (result === 1) {
        setDeleteModal(false);
        onClickObtainAppointment(
          String(values.StartDate),
          String(values.EndDate)
        );
        setMessageModal({
          title: t("modal.message"),
          message: t("modal.deleteSellOut"),
        });
        setOpenModal(true);
      } else {
        setDeleteModal(false);
        setMessageModal({
          title: t("header.validationError"),
          message: t("modal.generalError"),
        });
        setOpenModal(true);
      }
    } catch (error) {
      setDeleteModal(false);
      setMessageModal({
        title: t("header.validationError"),
        message: t("modal.generalError"),
      });
      setOpenModal(true);
    }
  };

  function formatDate(input: string): string {
    const [month, day, year] = input.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  function onClickObtainAppointment(
    StartDate: string | moment.Moment | undefined,
    EndDate: string | moment.Moment | undefined
  ): void {
    setCurrentPage(1);

    const today = moment();

    if (StartDate === undefined && EndDate === undefined) {
      StartDate = today.clone().startOf("month").format("YYYY-MM-DD");
      EndDate = today.clone().endOf("month").format("YYYY-MM-DD");
      setValues((prevState: IValuesAppointmentControl) => ({
        ...prevState,
        Date: today.format("YYYY-MM-DD"),
        StartDate: StartDate,
        EndDate: EndDate,
      }));
    }

    tableDataRef.current = [];
    setTableData([]);
    const column = getTableColumns("GetAppointmentControl");
    setValues((prevState: any) => ({
      ...prevState,
      Columns: column,
    }));
    setLoading(true);

    AgendaManagement.getAppointmentControl(String(StartDate), String(EndDate))
      .then((result: any[]) => {
        const updatedTableData = result.map((item) => {
          item.appointmentId = String(item.appointmentId);
          item.idUser = String(item.idUser);
          item.name = String(item.name);
          item.lastName = String(item.lastName);
          item.appointmentDate = formatDate(
            item.appointmentDate.replace(/ 00:00:00$/, "")
          );
          item.poscode = String(item.poscode);
          item.checkInTime = String(item.checkInTime);
          item.checkOutTime = String(item.checkOutTime);

          const row: Record<string, any> = {};

          column.forEach((col) => {
            if (col.id === "date") {
              row[col.id] = item[col.id].split("T")[0];
            } else {
              row[col.id] = item[col.id] || "";
            }
          });

          row.appointmentId = item.appointmentId;

          function handleActionRowConfig(
            e: any,
            option?: OptionInterface<OptionValue> | undefined
          ): void {
            if (option?.label === "Editar" || option?.label === "Edit") {
              fillUpdate(option?.value);
            } else if (
              option?.label === "Eliminar" ||
              option?.label === "Delete" ||
              option?.label === "Excluir"
            ) {
              setDeleteModal(true);
              setValueAppointmentDelete(Number(option?.value));
            }
          }

          return {
            ...row,
            rowConfig: {
              action: (
                <ContextualMenu
                  onClick={handleActionRowConfig}
                  options={[
                    {
                      value: item.appointmentId,
                      label: t("header.edit"),
                      icon: <IconPencil />,
                    },
                    {
                      value: item.appointmentId,
                      label: t("header.delete"),
                      icon: <IconTrash />,
                    },
                  ]}
                  placement="leading"
                />
              ),
              disabled: false,
              noWrap: false,
              selected: false,
            },
          };
        });

        tableDataRef.current = updatedTableData;
        setTableData(updatedTableData);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  const downloadTemplate = () => {
    const nameExcel = "AppointmentControl.xlsx";

    AgendaManagement.appointmentControlTemplate(languageID.value).then(
      (result: any) => {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nameExcel);
        document.body.appendChild(link);
        link.click();
      }
    );
    return;
  };

  function handleCreateAgenda(): void {
    setOpenModalCreateSellOut(true);
  }

  const handleOnClickExit = () => {
    setOpenModalCreateSellOut(false);
    setFileName("");
    setButtonNext(true);
  };

  const handleOnClickExitUpdate = () => {
    setOpenModalUpdateAppointment(false);
  };

  function getReasonText(reason: number) {
    switch (reason) {
      case 1:
        return t("header.errPoscodeNf");
      case 2:
        return t("header.errUserNf");
      case 3:
        return t("header.errTimeInvalid");
      case 4:
        return t("header.errUserPosNf");
      case 5:
        return t("header.errUserNfTime");
      case 6:
        return t("header.errPosNfTime");
      case 7:
        return t("header.errAllInvalid");
      case 8:
        return t("header.errDiffSubregion");
      case 9:
        return t("header.errPoscodeSubregion");
      case 10:
        return t("header.errTimeSubregion");
      case 11:
        return t("header.errPosTimeSubregion");
      default:
        return t("header.validationError");
    }
  }

  const handleOnClickNext = async () => {
    try {
      setOpenModalCreateSellOut(false);

      const response: any[] = await AgendaManagement.insertAppointmentControl(
        jsonDate
      );

      const cleanedData = response.map((item) => ({
        ...item,
        appointmentDate: (() => {
          const date = new Date(item.appointmentDate);
          if (isNaN(date.getTime())) return "";
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const day = date.getDate().toString().padStart(2, "0");
          return `${year}-${month}-${day}`;
        })(),
        checkInTime: item.checkInTime ? item.checkInTime.slice(0, 5) : "",
        checkOutTime: item.checkOutTime ? item.checkOutTime.slice(0, 5) : "",
        reason: getReasonText(item.reason),
      }));

      await generateExcel(cleanedData);

      onClickObtainAppointment(
        String(values.StartDate),
        String(values.EndDate)
      );
    } catch (error) {
      setMessageModal({
        title: t("header.validationError"),
        message: t("modal.generalError"),
      });
      setOpenModal(true);
    }
  };

  const handleOnClickNextUpdate = async () => {
    try {
      const json: IUpdateAppointmentControlDto = {
        IdUser: Number(values.Update.idUser),
        AppointmentId: Number(values.Update.appointmentId),
        AppointmentDate: values.Update.appointmentDate,
        Poscode: values.Update.poscode,
        CheckInTime: values.Update.checkInTime + ":00",
        CheckOutTime: values.Update.checkOutTime + ":00",
      };

      const response: number = await AgendaManagement.updateAppointmentControl(
        json
      );

      switch (response) {
        case 1:
          setOpenModalUpdateAppointment(false);
          onClickObtainAppointment(
            String(values.StartDate),
            String(values.EndDate)
          );
          break;
        case 2:
          setOpenModalUpdateAppointment(false);
          setMessageModal({
            title: t("header.validationError"),
            message: t("modal.errTimeOrder"),
          });
          setOpenModal(true);
          break;
        case 3:
          setOpenModalUpdateAppointment(false);
          setMessageModal({
            title: t("header.validationError"),
            message: t("modal.errPosNotFound"),
          });
          setOpenModal(true);
          break;
        case 4:
          setOpenModalUpdateAppointment(false);
          setMessageModal({
            title: t("header.validationError"),
            message: t("modal.errInvalidTimePos"),
          });
          setOpenModal(true);
          break;
        default:
          setOpenModalUpdateAppointment(false);
          setMessageModal({
            title: t("header.validationError"),
            message: t("modal.generalError"),
          });
          setOpenModal(true);
      }
    } catch (error) {
      setOpenModalUpdateAppointment(false);
      setMessageModal({
        title: t("header.validationError"),
        message: t("modal.generalError"),
      });
      setOpenModal(true);
    }
  };

  // Asegúrate de pasar cleanedData al generador
  const generateExcel = async (cleanedData: any[]) => {
    if (!cleanedData || cleanedData.length === 0) {
      setMessageModal({
        title: t("modal.message"),
        message: t("modal.appointmentControlOk"),
      });
      setOpenModal(true);
      return;
    }

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Agenda");

    // Definir las columnas
    worksheet.columns = [
      { header: t("header.userId"), key: "idUser", width: 10 },
      { header: t("header.name"), key: "name", width: 15 },
      { header: t("header.lastName"), key: "lastName", width: 15 },
      { header: t("header.date"), key: "appointmentDate", width: 15 },
      { header: t("header.posOfCode"), key: "poscode", width: 15 },
      { header: t("header.startTime"), key: "checkInTime", width: 15 },
      { header: t("header.endTime"), key: "checkOutTime", width: 15 },
      { header: t("header.reason"), key: "reason", width: 10 },
    ];

    // Agregar los datos
    cleanedData.forEach((item) => worksheet.addRow(item));

    // Establecer estilos para las celdas de encabezado
    worksheet.getRow(1).eachCell((cell, colNumber) => {
      const headerKey = worksheet.columns[colNumber - 1].key;
      cell.value = cell.value || headerKey;
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "00B0F0" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Ajustar el tamaño de las columnas según el contenido
    worksheet.columns.forEach((column) => {
      let maxLength = 0;

      worksheet.eachRow({ includeEmpty: true }, (row) => {
        if (column.key) {
          const cellValue = row.getCell(column.key).value;
          const cellLength = cellValue ? String(cellValue).length : 0;
          maxLength = Math.max(maxLength, cellLength);
        }
      });

      column.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "FailedAppointmentControl.xlsx");
    
    setMessageModal({
      title: t("modal.message"),
      message: t("modal.appointmentControlError"),
    });
    setOpenModal(true);
  };

  const onClearFilePicker = () => {
    setFileName("");
    setButtonNext(true);
    setErrorFilePicker(false);
  };

  function isFormulaWithResult(value: any): value is { result: any } {
    return (
      typeof value === "object" &&
      value !== null &&
      "formula" in value &&
      "result" in value
    );
  }

  function extractExcelTime(value: any): string {
    if (value instanceof Date) {
      const hours = value.getUTCHours();
      const minutes = value.getUTCMinutes();
      const seconds = value.getUTCSeconds();
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
    return "";
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileInput = e.target;

    if (fileInput.files) {
      const file = fileInput.files[0];
      setFileName(file.name);
      const reader = new FileReader();
      const fileType = file.name.split(".").pop();

      if (fileType?.toLowerCase() !== "xlsx") {
        setErrorFilePicker(true);
        return;
      } else {
        setErrorFilePicker(false);
        setButtonNext(false);
        reader.onload = async (event) => {
          const data = event.target?.result as ArrayBuffer;
          const workbook = new Workbook();
          await workbook.xlsx.load(data);

          const rows: any = [];

          const worksheet = workbook.worksheets.find(
            (ws) => ws.state === "visible"
          );

          if (worksheet) {
            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
              if (rowNumber !== 1) {
                const rowData = {
                  IdUser: row.getCell(1).value,
                  Name: row.getCell(2).value,
                  LastName: row.getCell(3).value,
                  AppointmentDate: row.getCell(4).value,
                  PosCode: row.getCell(5).value,
                  CheckInTime: row.getCell(6).value,
                  CheckOutTime: row.getCell(7).value,
                };

                // Transformación de datos
                const transformedData = {
                  IdUser: rowData.IdUser,
                  Name: isFormulaWithResult(rowData.Name)
                    ? rowData.Name.result
                    : rowData.Name,
                  LastName: isFormulaWithResult(rowData.LastName)
                    ? rowData.LastName.result
                    : rowData.LastName,
                  AppointmentDate:
                    rowData.AppointmentDate &&
                    rowData.AppointmentDate instanceof Date
                      ? rowData.AppointmentDate.toISOString().split("T")[0]
                      : "",
                  PosCode: String(rowData.PosCode),
                  CheckInTime: extractExcelTime(rowData.CheckInTime),
                  CheckOutTime: extractExcelTime(rowData.CheckOutTime),
                };

                const hasData = Object.values(rowData).some((cell) => {
                  if (cell === null || cell === undefined) return false;

                  if (
                    typeof cell === "object" &&
                    cell !== null &&
                    "formula" in cell &&
                    !("result" in cell)
                  ) {
                    return false;
                  }

                  if (typeof cell === "string" && cell.trim() === "")
                    return false;

                  return true;
                });

                if (hasData) {
                  rows.push(transformedData);
                }
              }
            });
          }
          setJsonDate(rows);
        };
      }

      reader.readAsArrayBuffer(file);
    }
  };

  function isValidTime(time: string): boolean {
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    return regex.test(time);
  }

  const changeHandlerUpdate = (
    value: moment.Moment | string | undefined,
    field: string
  ) => {
    let formattedValue: string = "";

    if (moment.isMoment(value)) {
      formattedValue = value.format("YYYY-MM-DD");
    } else if (typeof value === "string") {
      formattedValue = value;
    }

    setValues((prevState: any) => {
      const updatedValues = {
        ...prevState,
        Update: {
          ...prevState.Update,
          [field]: String(formattedValue),
        },
      };

      const { checkInTime, checkOutTime, poscode } = updatedValues.Update;

      const isTimeValid =
        (field === "checkInTime"
          ? isValidTime(formattedValue as string)
          : isValidTime(checkInTime)) &&
        (field === "checkOutTime"
          ? isValidTime(formattedValue as string)
          : isValidTime(checkOutTime));

      const isPosValid =
        field === "poscode"
          ? formattedValue.trim() !== ""
          : poscode && poscode.trim() !== "";

      if (isTimeValid && isPosValid) {
        setButtonNext(false);
      } else {
        setButtonNext(true);
      }

      return updatedValues;
    });
  };

  const handleDeleteUser = () => {
    deleteAppointmentControl(valueAppointmentDelete);
  };

  const onClickHelp = () => {
    setMessageModal({
      title: t("modal.message"),
      message: t("modal.helperAppointmentControl"),
    });
    setOpenModal(true);
  };

  const handleOnDateChange = (newDate: any) => {
    const today = newDate;

    let startDate: Moment, endDate: Moment;

    startDate = today.clone().startOf("month");
    endDate = today.clone().endOf("month");

    setValues((prevState: IValuesAppointmentControl) => ({
      ...prevState,
      Date: today.format("YYYY-MM-DD"),
      StartDate: startDate.format("YYYY-MM-DD"),
      EndDate: endDate.format("YYYY-MM-DD"),
    }));

    onClickObtainAppointment(
      startDate.format("YYYY-MM-DD"),
      endDate.format("YYYY-MM-DD")
    );
  };

  const isFutureDate = (day: MomentObj) => {
    return day.isAfter(moment(), "day");
  };

  return (
    <>
      <h4 style={{ padding: "20px" }}>{t("header.titleAppointmentControl")}</h4>

      <p style={{ marginLeft: "20px", marginRight: "50px" }}>
        <Trans
          i18nKey="header.descriptionAppointmentControl"
          components={{ bold: <b /> }}
          ns="global"
        />
      </p>

      <div className="groupAppointmentControl">
        <DatePicker
          clearIcon={false}
          label={t("header.date")}
          onChange={(newDate) => handleOnDateChange(newDate)}
          value={values.Date}
          format="ll"
          isOutsideRange={isFutureDate}
        />

        <DatePicker
          endDate={values.EndDate}
          format="ll"
          clearIcon={false}
          range
          startDate={values.StartDate}
          startDateLabel={t("header.stardDate")}
          endDateLabel={t("header.endDate")}
          disabled={true}
        />

        <Button style={{ margin: "10px" }} onClick={handleCreateAgenda}>
          {t("header.uploadFile")}
        </Button>

        <div className="tooltipAppointmentControl">
          <span className="tooltiptextAppointmentControl">
            {t("header.downloadFile")}
          </span>
          <Button
            style={{ margin: "5px" }}
            leadingIcon={<IconDocument />}
            onClick={() => downloadTemplate()}
          ></Button>
        </div>

        <div className="tooltipAppointmentControl">
          <span className="tooltiptextAppointmentControl">
            {t("modal.titleHelper").replace(":", "?")}
          </span>
          <Button
            style={{ margin: "5px" }}
            leadingIcon={<IconHelp />}
            onClick={() => onClickHelp()}
          ></Button>
        </div>
      </div>

      {values.Columns.length > 0 && (
        <div style={{ padding: "20px" }}>
          <Card
            appearance="outlined"
            className="divTableAppointmentControl"
            content={
              <Table
                className="tableAppointmentControl"
                behavior={{
                  type: "singlePage",
                }}
                pagination={paginationProps}
                columnResize
                showFilters={true}
                loading={loading}
                columns={values.Columns}
                data={pagedData}
                loadingDataLength={5}
                customNoItems={
                  <div className="customNoItems">
                    <div className="DivIconCustomNoItems">
                      <IconWarningAlt className="IconCustomNoItems" />
                    </div>
                    {t("header.noItemsFound")}
                  </div>
                }
              />
            }
          />
        </div>
      )}

      <ModalInformational
        idKey="modal-DeleteOk"
        setOpenCloseModal={() => setOpenModal(false)}
        openModal={openModal}
        titleMessage={messageModal.title}
        message={messageModal.message}
        onClickOk={() => setOpenModal(false)}
      />

      <Modal
        align="start"
        id="modal-id"
        show={openDeleteModal}
        onClose={() => setDeleteModal(false)}
        footer={
          <Group>
            <Button onClick={handleDeleteUser}>Si</Button>
            <Button
              appearance="secondary"
              onClick={() => setDeleteModal(false)}
            >
              No
            </Button>
          </Group>
        }
        title={t("modal.warningTitle")}
      >
        <p>{t("modal.questionDeleteSellOut")}</p>
      </Modal>

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          id="modal-createSellOut"
          show={openModalCreateSellOut}
          onClose={() => setOpenModalCreateSellOut(false)}
          footer={
            <div className="buttonGroupAppointmentControl">
              <Group>
                <Button onClick={handleOnClickExit} appearance="secondary">
                  {t("header.closebutton")}
                </Button>
                <Button
                  disabled={buttonNext}
                  onClick={() => handleOnClickNext()}
                >
                  {t("header.submit")}
                </Button>
              </Group>
            </div>
          }
          title={t("header.addAgenda")}
        >
          <div>
            <h5>{t("header.uploadFile")}</h5>
            <FilePicker
              className="modalAppointmentControlFile"
              id="selOut-file-picker"
              label={t("header.uploadFile")}
              accept=".xlsx"
              onChange={handleFileChange}
              onClear={onClearFilePicker}
              value={fileName}
              error={errorFilePicker}
              helperText={t("header.messageXLSX")}
            />
          </div>
        </Modal>
      </div>

      <div>
        <Modal
          align="start"
          id="modal-updateAppointment"
          show={openModalUpdateAppointment}
          onClose={() => setOpenModalUpdateAppointment(false)}
          footer={
            <div className="buttonGroup">
              <Group>
                <Button
                  onClick={handleOnClickExitUpdate}
                  appearance="secondary"
                >
                  {t("header.closebutton")}
                </Button>
                <Button
                  disabled={buttonNext}
                  onClick={() => handleOnClickNextUpdate()}
                >
                  {t("header.submit")}
                </Button>
              </Group>
            </div>
          }
          title={t("header.update")}
        >
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
              <TextBox
                id="name"
                label={t("header.name")}
                value={values.Update.name}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <TextBox
                id="lastname"
                label={t("header.lastName")}
                placeholder={t("header.lastName")}
                value={values.Update.lastName}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <DatePicker
                className="customAppointmentControlDatePicker"
                clearIcon={false}
                label={t("header.date")}
                onChange={(date) =>
                  changeHandlerUpdate(date as moment.Moment, "appointmentDate")
                }
                orientation="horizontal"
                placeholder="YYYY-MM-DD"
                value={values.Update.appointmentDate}
                format="ll"
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <TextBox
                id="posCode"
                label={t("header.posOfCode")}
                placeholder={t("header.posOfCode")}
                onChange={(text: string) =>
                  changeHandlerUpdate(text, "poscode")
                }
                value={values.Update.poscode}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <TextBox
                id="startTime"
                label={t("header.startTime")}
                placeholder={t("header.startTime")}
                onChange={(text: string) =>
                  changeHandlerUpdate(text, "checkInTime")
                }
                value={values.Update.checkInTime}
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <TextBox
                id="endTime"
                label={t("header.endTime")}
                placeholder={t("header.endTime")}
                onChange={(text: string) =>
                  changeHandlerUpdate(text, "checkOutTime")
                }
                value={values.Update.checkOutTime}
              />
            </Grid>
          </Grid>
        </Modal>
      </div>
    </>
  );
}
